export default __webpack_public_path__ + "i18n/translations/translation-nl.2770ccd6.json";